import * as React from 'react';
import { formField, IformField } from 'framework/components/hoc/formField';
import { SwitchPrimitive, SwitchPrimitiveTypes } from '../Primitives/SwitchPrimitive';

export const Switch = (props: SwitchPrimitiveTypes) => <SwitchPrimitive {...props as any} />;

export default (formField(Switch) as any) as React.StatelessComponent<
SwitchPrimitiveTypes & IformField
>;
